import { useMountEffect } from "@companion-core/shared/app/Hooks/useMountEffect";

import { useDynamicPageParams } from "../hooks/dynamicPageHooks";

export const RedirectToNotFound = () => {
  const { redirectToNotFound } = useDynamicPageParams();
  useMountEffect(() => {
    redirectToNotFound();
  });
  return null;
};
